module.exports = __webpack_public_path__ + "static/media/commission-europeenne.dcd36b1a.png";